import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const TopCaptionsContainer = styled.div`

`;

export const Caption = styled.span`
  font-size: 0.75rem;
  font-style: italic;
  display: block;
`;